export const _ITEM_ID_ = '_id_';
export const _ITEM_DATA_ = '_data_';
export const _ITEM_VALUE_ = '_value_';
export const _ITEM_INDEX_ = '_index_';
export const _ITEM_PATH_ = '_path_';
export const _ITEM_CHILDREN_ = '_children_';
export const VARIABLE_FORMAT_REGEX = /\{(.*?)\}/g;